<template>
	<div class="monitor-item-component" :class="{'active':session_id == source.sessionId}" @click="clickTab(source)">
		<div class="avatar-box">
			<img src="https://assistant-cdn.porsche-scrm-engagement.com/static/images/avator.png"/>
		</div>
		<div class="card-box">
			<div class="title">
				<span class="nickname">{{$$(source.customerInfo,'nickname')}}</span>
			</div>
			<div class="desc">
				<p>
					<span class="text"><i class="iconfont" :class="getSourceIcon(source.customerInfo)"></i></span>
					<time>{{formateDate(source)}}</time>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			source: {
			  type: Object,
			  default () {
				return {}
			  }
			},
			session_id: {
			  type: String,
			  default () {
				return ''
			  }
			},
		},
		methods:{
			clickTab(data){
				let parent = this.$parent;
				parent = parent.$parent;
				parent.$emit('toClickItem',data);
			},
			formateDate(data){
				return this.$dayjs(data.updateTime).format('YYYY-MM-DD HH:mm:ss')
			},
			getSourceIcon(row){
				let type = row.channel;
				let icon = '';
				switch(type){
					case 'wechat':
						icon = 'major-weixin'
						break;
					case 'web':
						icon = 'major-wangzhan'
						break;
					case 'weibo':
						icon = 'major-weibo2'
						break;
					case 'miniProgram':
						icon = 'major-weixinxiaochengxu'
						break;
					case 'tikTok':
						icon = 'major-douyintexiao'
						break;
					case 'qyWechat':
						icon = 'major-qiyeweixin'
						break;
					case 'Baiduminiprogram':
						icon = 'major-baidu'
						break;
					case 'JDongminiprogram':
						icon = 'major-jingdong'
						break;
					case 'app':
						icon = 'major-44'
						break;
				}
				return icon
			}
		}
	}
</script>

<style lang="scss" scoped>
	.monitor-item-component {
		padding: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		&:hover {
			background: #F6F7F9;
		}
		&.active {
			background-color: #edf5ff;
		}
		.avatar-box {
			width: 45px;
			height: 45px;
			flex-shrink: 0;
			background-color: #508afe;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: white;
			position: relative;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
				background-color: white;
			}
		}
		.card-box {
			display: flex;
			align-content: center;
			flex-direction: column;
			flex: 1 1;
			margin-left: 10px;
			width: calc(100% - 45px);
			time {
				float: right;
				color: #838a9d;
				font-size: 12px;
			}
			.title {
				 line-height: 22px;
				.nickname {
					 font-size: 14px;
					 color: #3c4353;
					 font-weight: 500;
					 display: inline-block;
					 width: 100%;
					 overflow: hidden;
					 text-overflow: ellipsis;
					 white-space: nowrap;
					 line-height: 22px;
				}
			}
			.desc {
				line-height: 22px;
				.text {
					font-size: 12px;
					color: #838a9d;
				}
			}
			
		}
	}
</style>
